import React from 'react'
import { MainTemplate } from '../../templates/MainTemplate'
import { useDashboardPage } from './hook'
import { Card } from '../../molecules/DashboardCard';
import styled from 'styled-components';


export const DashboardPage = () => {
  const { dashboardData } = useDashboardPage();

  return (
    <MainTemplate title="Dashboard" useFitHeight>
      {dashboardData && (
        <StyledCardContainer>
          <CardWrapper>
            <Card title="Total properties" value={dashboardData.total_properties} />
          </CardWrapper>
          <CardWrapper>
            <Card title="Total owners" value={dashboardData.total_owners} />
          </CardWrapper>
          <CardWrapper>
            <Card title="Total Rent property" value={dashboardData.total_rent_properties} />
          </CardWrapper>
          <CardWrapper>
            <Card title="Total Sale properties" value={dashboardData.total_sale_properties} />
          </CardWrapper>
        </StyledCardContainer>
      )}
    </MainTemplate>
  )
}

const StyledCardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 32px 40px;
  max-width: 600px;
  padding: 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    gap: 16px;
  }
`;

const CardWrapper = styled.div``;